<template>
  <div>
    <div>
      <!-- Banner start here -->

      <section class="banner" style="width:100%;">
        <div class="homeSlider slick-initialized slick-slider slick-dotted">
          <div>
            <!-- class="slick-list draggable" -->
            <div style="width:100%;height:500px;position:relative">
              <!-- class="slick-track" -->
              <!-- 第二个轮播图 -->
              <div
                class="slides slick-slide slick-current slick-active"
                data-slick-index="1"
                aria-hidden="false"
                role="tabpanel"
                id="slick-slide01"
                style="width: 100%; position: relative; left: 0px; top: 0px;
                 background:#fff url(https://image.insideburgundy.cn/insideburgundy/20190523/9872ca4790204ce4b1834ec0be6660f7.png) center center no-repeat;
                background-size:100%;
                "
                aria-describedby="slick-slide-control01"
              >
                <div class="container">
                  <div class="caption">
                    <div>
                      <h1>2002年份勃艮第品鉴报告</h1>
                      <p>
                        2019年1月，我在香港美国俱乐部参加了一次令人愉悦的2002年勃艮第酒品鉴晚宴。这是当晚品鉴的全部酒款。
                      </p>
                      <a href="#/Qualification?id=21" target class="btn" tabindex="0">阅读更多</a>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 第三个轮播图 -->
              <div
                class="slides slick-slide"
                data-slick-index="2"
                aria-hidden="true"
                role="tabpanel"
                id="slick-slide02"
                style="width: 100%; position: absolute; left: 0px; top: 0px;
                background:#fff url(https://image.insideburgundy.cn/insideburgundy/20190523/bc3c58c31f184d0db4abf8596786bd03.png) center center no-repeat;
                 background-size:100%;
                "
                aria-describedby="slick-slide-control02"
                tabindex="-1"
              >
                <div class="container">
                  <div class="caption">
                    <div>
                      <h1>最新资讯</h1>
                      <p>探索勃艮第，掌握最新动态</p>
                      <a
                        href="#/report"
                        target
                        class="btn"
                        tabindex="-1"
                      >立即查看</a>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 第一个轮播图 -->
              <div
                class="slides slick-slide "
                data-slick-index="0"
                aria-hidden="true"
                role="tabpanel"
                id="slick-slide00"
                style="width: 100%; position: absolute; left: 0px; top: 0px;
                  background:#fff url(https://image.insideburgundy.cn/insideburgundy/20190523/17ad3d5dd5ee4ed9888dd4da23c706e8.png) center center no-repeat;
                   background-size:100%;
                "
                aria-describedby="slick-slide-control00"
                tabindex="-1"
              >
                <div class="container">
                  <div class="caption" >
                    <div>
                      <h1>欢迎订阅</h1>
                      <p>800元/年获得最新勃艮第酒评，掌握勃艮第即时动态，尽享探索勃艮第乐趣</p>
                      <a
                        href="#/Subscribe"
                        target
                        class="btn"
                        tabindex="-1"
                      >立即订阅</a>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <ul class="slick-dots" style="display: block;" role="tablist">
            <li class role="presentation">
              <button
                type="button"
                role="tab"
                id="slick-slide-control00"
                aria-controls="slick-slide00"
                aria-label="1 of 3"
                tabindex="-1"
              >1</button>
            </li>
            <li role="presentation" class="slick-active">
              <button
                type="button"
                role="tab"
                id="slick-slide-control01"
                aria-controls="slick-slide01"
                aria-label="2 of 3"
                tabindex="0"
                aria-selected="true"
              >2</button>
            </li>
            <li role="presentation" class>
              <button
                type="button"
                role="tab"
                id="slick-slide-control02"
                aria-controls="slick-slide02"
                aria-label="3 of 3"
                tabindex="-1"
              >3</button>
            </li>
          </ul>
        </div>
        <div class="container">
          <div id="homePagination" class="sliderPagination slick-initialized slick-slider" style>
            <div class="slick-list draggable">
              <div
                class="slick-track"
                style="opacity: 1; width: 948px; transform: translate3d(0px, 0px, 0px);"
              >
                <div
                  class="slides slick-slide slick-active slick-current"
                  style="width: 316px;"
                  data-slick-index="0"
                  aria-hidden="false"
                  tabindex="-1"
                >
                  <h6>欢迎订阅</h6>
                  <p>800元/年获得最新勃艮第酒评，掌握勃艮第即时动态，尽享探索勃艮第乐趣</p>
                </div>
                <div
                  class="slides slick-slide slick-active "
                  style="width: 316px;"
                  data-slick-index="1"
                  aria-hidden="false"
                >
                  <h6>2002年份勃艮第品鉴报告</h6>
                  <p>2019年1月，我在香港美国俱乐部参加了一次令人愉悦的2002年勃艮第酒品鉴晚宴。这是当晚品鉴的全部酒款。</p>
                </div>
                <div
                  class="slides slick-slide slick-active"
                  style="width: 316px;"
                  data-slick-index="2"
                  aria-hidden="false"
                >
                  <h6>最新资讯</h6>
                  <p>探索勃艮第，掌握最新动态</p>
                </div>
              </div>
            </div>
          </div>

          <searchBox/>
        </div>
      </section>
      <!-- Banner end here -->

      <!-- Main content area start here -->
      <section class="homeContent">
        <div class="container">
          <!-- Top 3 blocks -->
          <div class="gridBoxes three">
            <ul>
              <li class="animate fadeInUp triggeredCSS3">
                <div class="content">
                  <div class="img">
                    <a href="#/JASPER" target>
                      <img
                        src="https://image.insideburgundy.cn/insideburgundy/20190523/51e7a73aaf024366b8830ba02cc9cd1b.png"
                        alt="About Jasper"
                        class="cover-image"
                      >
                    </a>
                  </div>
                  <div class="discription">
                    <h6>
                      <a href="#/JASPER" target>
                        关于Jasper Morris MW
                      </a>
                    </h6>我自1979年开始进入葡萄酒行业，很快我就和勃艮第结缘，2013年我和合伙人将公司卖给英国老牌酒商BBR（Berry Bros &Rudd）后，我一直在BBR担任勃艮第的买手和总监一职，直到2017年退休。在我的职业生涯中，我在1985年成为一名葡萄酒大师Master of Wine，并与2010年出版了我的勃艮第专著《Inside Burgundy》。
                    <a
                      href="#/JASPER"
                      target
                      class="readmore"
                    >阅读更多</a>
                  </div>
                </div>
              </li>
              <li class="animate fadeInUp triggeredCSS3">
                <div class="content">
                  <div class="img">
                    <a href="#/JASPER" target>
                      <img
                        src="https://image.insideburgundy.cn/ningbo2.jpeg"
                        alt="关于梅宁博"
                        class="cover-image"
                      >
                    </a>
                  </div>
                  <div class="discription">
                    <h6>
                      <a href="#/JASPER" target>
                        关于梅宁博
                      </a>
                    </h6>2009年我偶然之间参加了一场葡萄酒品鉴会，那是勃艮第葡萄酒行业协会BIVB在中国做的第一场推广活动。一款来自夏布利产区的白葡萄酒让我心驰神往，我立刻决定辞掉当时的工作开始学习葡萄酒。经历了九九八十一难之后，我被全世界名列前茅的葡萄酒高校勃艮第商学院葡萄酒专业所录取，在此期间，我深入地学习法国尤其是勃艮第产区的葡萄酒，最终获得该校葡萄酒硕士学位。
                    <a
                      href="#/JASPER"
                      target
                      class="readmore"
                    >阅读更多</a>
                  </div>
                </div>
              </li>
              <li class="animate fadeInUp triggeredCSS3">
                <div class="content">
                  <div class="img">
                    <a href="#/Burgundy" target>
                      <img
                        src="https://image.insideburgundy.cn/insideburgundy/20190523/b0c3e26870b245ae8745b4b2aa73eb9c.png"
                        alt="About Burgundy"
                        class="cover-image"
                      >
                    </a>
                  </div>
                  <div class="discription">
                    <h6>
                      <a href="#/Burgundy" target>关于勃艮第</a>
                    </h6>勃艮第在人类历史上一直有显著的地位，从公元5世纪开始一个叫“勃艮“的部落来到法国并驻扎到这里，到一千年后勃艮第公国成为欧陆最富有的王国，再到今天出产伟大葡萄酒的勃艮第产区。
                    <a
                      href="#/Burgundy"
                      target
                      class="readmore"
                    >阅读更多</a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <!-- Top 3 blocks -->

          <!-- Why subscribe -->
          <div class="whySubscribe">
            <div class="whySubscribeText animate fadeInUp triggeredCSS3" style="width: 58%;">
              <a href="#/Subscribe" style="text-decoration:none;">
                <h1>欢迎订阅网站内容</h1>
              </a>
              <ul>
                <li>通过订阅您将获得所有的品鉴报告及过往酒评</li>
                <li>您可通过网页、微信小程序、App（开发中）全平台查看酒评，方便快捷</li>
                <li>做为订阅用户，您将获赠Inside Burgundy的定制版Riedel勃艮第酒杯一支</li>
                <li>订阅费用为800元/年</li>
              </ul>
              <a href="#/Subscribe" target class="btn white">立即订阅</a>
            </div>
            <div class="whySubscribeImg animate fadeInUp triggeredCSS3">
              <img
                src="https://image.insideburgundy.cn/insideburgundy/20190522/67ff277f0d08400ea0f668ea933c40ea.png"
                alt="Why Subscribe?"
                class="cover-image"
              >
            </div>
          </div>
          <!-- Why subscribe -->

          <!-- Latest News -->
          <div class="gridBoxes four">
            <h2 class="animate fadeInUp triggeredCSS3">最新资讯</h2>
            <ul>
              <li class="animate fadeInUp triggeredCSS3" v-for="item in newlatest" :key='item.id'>
                <div class="content">
                  <a :href="`#/latestinformation?id=${item.id}`">
                    <div class="img">
                      <img
                        :src="item.image"
                        alt="Frost Patrol: Sunday April 14th"
                        class="cover-image"
                      >
                    </div>
                  </a>
                  <div class="discription">
                    <h6>
                      <a :href="`#/latestinformation?id=${item.id}`">
                        {{item.title}}
                      </a>
                    </h6>
                    {{item.introduction}}
                  </div>
                  <a :href="`#/latestinformation?id=${item.id}`" class="readmore">阅读更多</a>
                </div>
              </li>

            </ul>
          </div>
          <!-- Latest News -->
        </div>
      </section>

      <!-- Subsribe Form section Bottom -->
      <!-- Subsribe Form section Bottom -->

      <!-- Main content area end here -->
    </div>
    <!--version 4.2 -->
  </div>
</template>
<style>
* input,
textarea {
  -webkit-touch-callout: none;
}
body {
  -webkit-touch-callout: none;
}
</style>


<script>
// $(function(){
//   $(".aaa").click(function(){
//     $(this).toggleClass("slick-current").siblings().removeClass("slick-current");
//     $(".caption h1").html("Subscribe Today");
//     $(".caption p").html("Only £95.00 a year will give you full access to Inside Burgundy.");
//     $(".slides img").attr("src","https://www.insideburgundy.com/wp-content/uploads/2018/08/banner-1.jpg");
//   })
//   $(".bbb").click(function(){
//     $(this).toggleClass("slick-current").siblings().removeClass("slick-current");
//     $(".caption h1").fadeIn(3000).html("Burgundy 2017: Chablis notes now live");
//     $(".caption p").fadeIn(3000).html("See Jasper's notes and scores on more than 300 Chablis wines.");
//     $(".slides img").fadeIn(3000).attr("src","https://www.insideburgundy.com/wp-content/uploads/2018/12/chablis-20172.jpg");
//   })
//   $(".ccc").click(function(){
//     $(this).toggleClass("slick-current").siblings().removeClass("slick-current");
//     $(".caption h1").html("Latest News from Burgundy");
//     $(".caption p").html("Discover what is happening Inside Burgundy right now...");
//     $(".slides img").attr("src","https://www.insideburgundy.com/wp-content/uploads/2018/09/barrels-1-1600x600.jpg");
//   })
// })
import searchBox from "../template/search";
import ajax from '../ajax';

export default {
  data() {
    return {
      newlatest:[],
      bannerN:0,
      Timeout:''
    }
  },
  components: {
    searchBox
  },
  created() {
    this.getNewlatest()
  },
  mounted() {
    this.bannerControl()
    this.setBannerShow(0);
    this.Timeout = setInterval(() => {
      if(this.bannerN<2)
      this.bannerN++
      else
      this.bannerN = 0
    }, 8000);
  },
  beforeDestroy() {
    if(this.Timeout){
      clearInterval(this.Timeout)
    }
  },
  methods: {
      getNewlatest(){
    ajax.getNewsLatest().then(res=>{
      this.newlatest = res.data
    })
  },
    //跳转页面
    bannerControl(){
      // slick-index
      let _this = this;
    let banner =  $('.homeSlider').find('.slides.slick-slide');
    let control = $('.sliderPagination').find('.slides.slick-slide').click(function(){
      control.removeClass('slick-current');
      _this.bannerN = $(this).addClass('slick-current').data('slick-index')
      let then = this
    $.each(banner,(index,item)=>{
       if($(then).data('slick-index') == $(item).data('slick-index')){
         $(item).fadeIn(700)
       }else{
         $(item).fadeOut(700)
       }
    })
    })

    },
    setBannerShow(n){
      let banner =  $('.homeSlider').find('.slides.slick-slide');
      let control = $('.sliderPagination').find('.slides.slick-slide')
      banner.each((index,item)=>{
        if(n == $(item).data('slick-index')){
         $(item).fadeIn(700)
       }else{
         $(item).fadeOut(700)
       }
      })

      control.each((index,item)=>{
        if(n == $(item).data('slick-index')){
         $(item).addClass('slick-current')
       }else{
         $(item).removeClass('slick-current')
       }
      })

    },

    hreftwo() {
      this.$router.push({ path: "./insideburgundy" });
    }
  },
  watch: {
    bannerN(n){
      this.setBannerShow(n)
    }
  },
};
</script>
<style>
.searchForm {
  position: relative;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue